// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 5 hooks for backend/rides.

import { useBackend } from '../useBackend'

/** POST /api/rides/cancelRide */
export function useCancelRide<T = any>() {
  return useBackend<T>('rides/cancelRide')
}

/** POST /api/rides/correctRideFare */
export function useCorrectRideFare<T = any>() {
  return useBackend<T>('rides/correctRideFare')
}

/** POST /api/rides/getRideOptions */
export function useGetRideOptions<T = any>() {
  return useBackend<T>('rides/getRideOptions')
}

/** POST /api/rides/getRides */
export function useGetRides<T = any>() {
  return useBackend<T>('rides/getRides')
}

/** POST /api/rides/logRide */
export function useLogRide<T = any>() {
  return useBackend<T>('rides/logRide')
}
